import { render, staticRenderFns } from "./Symmetry.vue?vue&type=template&id=3c55adcc&scoped=true"
import script from "./Symmetry.vue?vue&type=script&lang=js"
export * from "./Symmetry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c55adcc",
  null
  
)

export default component.exports